export default "__VITE_ASSET__Buev$Zsn__"